// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './style.css'; // Import your global CSS
import '@fortawesome/fontawesome-free/css/all.css';
import * as Sentry from "@sentry/vue";

const app = createApp(App);

Sentry.init({
  app,
  dsn: "https://f7769b74efbeef79de152d2ba31e0eff@o4509128937308160.ingest.us.sentry.io/4509128940388352"
});

app.use(router);
app.mount('#app');

